<template>
  <main>
    <section>
      <slot />
    </section>

    <footer>
      <div class="infos">v {{ runtimeConfig.public.version }}</div>
    </footer>
  </main>
</template>
<script lang="ts" setup>
const runtimeConfig = useRuntimeConfig();
</script>
<style lang="scss" scoped>
html,
body {
  min-height: 100%;
}
.logo {
  margin: 2rem auto -2rem;
}
main {
  display: grid;
  position: relative;
  z-index: 0;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr auto;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  min-height: 100dvh;
}
section {
  display: flex;
  position: relative;
  z-index: 1;
  gap: var(--gap_m);
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
footer {
  position: absolute;
  right: 1rem;
  bottom: 0.15rem;
  @include above('l') {
    right: 0.5rem;
    bottom: 0.5rem;
  }
  .infos {
    color: var(--color_neutral_100);
    @include font('xxs', '500');
  }
}
</style>
